<template>
  <v-container>
    <Home/>
  </v-container>
</template>

<script>

import Home from "@/components/templates/Home";

export default {
  components: { Home},
};
</script>
